import { render } from "./setpsTree.vue?vue&type=template&id=0710a503&scoped=true"
import script from "./setpsTree.vue?vue&type=script&lang=js"
export * from "./setpsTree.vue?vue&type=script&lang=js"

import "./setpsTree.vue?vue&type=style&index=0&id=0710a503&lang=less&scoped=true"
import "./setpsTree.vue?vue&type=style&index=1&id=0710a503&lang=less"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0710a503"]])

export default __exports__